import React from 'react';
import DecisionInfo from './DecisionInfo';
import { Grid, Cell } from 'react-foundation';

import './css/Modal.css';
import './css/foundation.css';

const ModalDialog = ({ handleClose, handleApprove, handleDeny, show, modalData }) => {
    const showHideClassName = show ? "modal display-block" : "modal display-none";
    const emailHref = "mailto:" + modalData.email;
    var requestDate = "";

    if (modalData.requestDate !== undefined) {
        const jsDate = new Date(modalData.requestDate);
        requestDate = new Intl.DateTimeFormat('en-US').format(jsDate);
    }

    return (
        <div className={showHideClassName}>
            <section className="modal-main">
                <button aria-label="Close" aria-labelledby="close-modal" className="_modal-close" onClick={handleClose}>
                    <span id="close-modal" className="_hide-visual">
                        Close
                    </span>
                    <svg className="_modal-close-icon" viewBox="0 0 40 40">
                        <path d="M 10,10 L 30,30 M 30,10 L 10,30" />
                    </svg>
                </button>
                <Grid className="modal-body">
                    <Cell>
                        <Grid>
                            <Cell medium={12} large={12} small={12} className="redtext">
                                <h4>REQUEST INFORMATION</h4>
                            </Cell>
                        </Grid>
                        <Grid>
                            <Cell medium={6} large={6} small={6} className="form-label">Request Date</Cell>
                            <Cell medium={6} large={6} small={6}>{requestDate}</Cell>
                            <Cell medium={6} large={6} small={6} className="form-label">Status</Cell>
                            <Cell medium={6} large={6} small={6}>{modalData.status}</Cell>
                            <DecisionInfo decisionData={modalData} />
                        </Grid>
                        <Grid className="header-spacing">
                            <Cell medium={12} large={12} small={12} className="redtext">
                                <h4>PERSONAL INFORMATION</h4>
                            </Cell>
                        </Grid>
                        <Grid>
                            <Cell medium={6} large={6} small={6} className="form-label">First Name</Cell>
                            <Cell medium={6} large={6} small={6}>{modalData.firstName}</Cell>
                            <Cell medium={6} large={6} small={6} className="form-label">Last Name</Cell>
                            <Cell medium={6} large={6} small={6}>{modalData.lastName}</Cell>
                            <Cell medium={6} large={6} small={6} className="form-label">Email</Cell>
                            <Cell medium={6} large={6} small={6}><a href={emailHref}>{modalData.email}</a></Cell>
                            <Cell medium={6} large={6} small={6} className="form-label">Title</Cell>
                            <Cell medium={6} large={6} small={6}>{modalData.title}</Cell>
                            <Cell medium={6} large={6} small={6} className="form-label">Phone</Cell>
                            <Cell medium={6} large={6} small={6}>{modalData.phone}</Cell>
                        </Grid>
                        <Grid className="header-spacing">
                            <Cell medium={12} large={12} small={12} className="redtext">
                                <h4>PRACTICE INFORMATION</h4>
                            </Cell>
                        </Grid>
                        <Grid>
                            <Cell medium={6} large={6} small={6} className="form-label">Name</Cell>
                            <Cell medium={6} large={6} small={6}>{modalData.practiceName}</Cell>
                            <Cell medium={6} large={6} small={6} className="form-label">Address</Cell>
                            <Cell medium={6} large={6} small={6}>{modalData.practiceStreetAddress}</Cell>
                            <Cell medium={6} large={6} small={6} className="form-label"></Cell>
                            <Cell medium={6} large={6} small={6}>{modalData.practiceCity}, {modalData.practiceState}  {modalData.practiceZip}</Cell>
                            <Cell medium={6} large={6} small={6} className="form-label">Tax ID</Cell>
                            <Cell medium={6} large={6} small={6}>{modalData.practiceTaxId}</Cell>
                        </Grid>
                        <Grid className="header-spacing">
                            <Cell medium={12} large={12} small={12} className="redtext">
                                <h4>SIGNATURE</h4>
                            </Cell>
                        </Grid>
                        <Grid>
                            <Cell medium={6} large={6} small={6} className="form-label">Signature</Cell>
                            <Cell medium={6} large={6} small={6}>{modalData.signature}</Cell>
                        </Grid>
                    </Cell>
                    <Cell>
                        <Grid className="footer-spacing">
                            <Cell small={4} offsetOnSmall={1}>
                                <button className="a-btn-main button-standard" onClick={handleApprove}>
                                    Approve
                                </button>
                            </Cell>
                            <Cell small={2}>
                            </Cell>
                            <Cell small={4}>
                                <button className="a-btn-main button-standard" onClick={handleDeny}>
                                    Deny
                                </button>
                            </Cell>
                        </Grid>
                    </Cell>
                </Grid>
            </section>
        </div>
    );
};

export default ModalDialog;